import type { ObjectPaymentReportRow } from '@econtractor/types';
import { useTranslation } from 'react-i18next';
import EmptyResult from 'components/others/EmptyResult';
import ReportObjectPaymentsTotals from '../ReportObjectPaymentsTotals';
import ReportObjectPaymentsTableRow from './ReportObjectPaymentsTableRow';
import { usePaymentReport } from '../context/ReportObjectPaymentsProvider';

const ReportObjectPaymentsTableBody = ({ rows }: { rows: ObjectPaymentReportRow[] }) => {
    const { t } = useTranslation(['Reports']);
    const report = usePaymentReport();
    const columnCount = report.objectId === undefined ? 6 : 5;
    return (
        <tbody>
            {rows.map((row) => <ReportObjectPaymentsTableRow key={row.ID} row={row} />)}
            {!rows.length ? <tr><td colSpan={columnCount}><EmptyResult /></td></tr> : (
                <tr className="fw-bold">
                    <td colSpan={columnCount}>
                        <div className="d-flex flex-wrap justify-content-between align-items-center gap-2">
                            <span>{t('objectPayments.total')}</span>
                            <ReportObjectPaymentsTotals rows={rows} />
                        </div>
                    </td>
                </tr>
            )}
        </tbody>
    );
};

export default ReportObjectPaymentsTableBody;
